import apiClient from '../axios';
import _ from "lodash";

export async function list(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  if (!_.isEmpty(filter)) {

    return apiClient
      .post(`/country/${countryId}/registrations?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
  }

  return apiClient
    .get(`/country/${countryId}/registrations?${pageQuery}${sortingQuery}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function members(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/registrations/members?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function contacts(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/registrations/contacts?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function parents(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/registrations/parents?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printContacts(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/contacts/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printParents(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/parents/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printMembers(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/members/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function print(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrations(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsMembers(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/members/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsContacts(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/contacts/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsParents(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/parents/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function emails(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/registrations/emails?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function details(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/registrations/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function move(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/registrations/${id}/move`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put(`/country/${data.countryId}/registrations`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(countryId, id, data) {
  return apiClient
    .post(`/country/${countryId}/registrations/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function changeIsDeactivated(id, isDeactivated) {
  return apiClient
    .post(`/registrations/${id}`, {is_deactivated: isDeactivated})
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function remove(countryId, id) {
  return apiClient
    .delete(`/country/${countryId}/registrations/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
